
import { handleActions } from 'redux-actions'
import { APP_STEP, step, message, apiConfigResolved } from './../actions/app'
const stepValues = Object.values(APP_STEP)

const initialState = {
  step: APP_STEP.START_UP,
  message: '',
  restart: false,
  apiConfig: null,
}

export const appReducer = handleActions({
  [apiConfigResolved] (prevState, action) {
    return {
      ...prevState,
      apiConfig: action.payload
    }
  },
  [step] (prevState, action) {
    if (stepValues.indexOf(action.payload) === -1) {
      throw new Error(`Invalid step value ${action.payload}`)
    }
    return {
      ...prevState,
      step: action.payload,
      restart: action.payload === APP_STEP.RTC_RESTARTING ? true : prevState.restart
    }
  },
  [message] (prevState, action) {
    return {
      ...prevState,
      message: action.payload
    }
  },
}, initialState)
